import { generatePath, NavLink } from 'react-router-dom';
import { IconLoader, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';

// types
import ROUTES from '../../../routes';
import { ColumnAccountsTypes } from './types';

// components
import ColumnHead from './column-head';

// styles
import cn from './column.module.css';

const ColumnPrimaryAccounts = ({
  path,
  accounts,
  groupId,
  categoryId,
  isLoading,
}: ColumnAccountsTypes) => {
  const { activePermissions } = useAppSelector((state) => state.root);

  let content;

  if (isLoading && groupId !== 'groupId') {
    content = (
      <div className={cn.columnLoader}>
        <IconLoader />
      </div>
    );
  } else {
    content = accounts?.map((item) => (
      <NavLink
        key={item.id}
        className={`${cn.columnItem} ${
          !activePermissions?.includes(
            PermissionEnum.ACCOUNTS_CHART_EDIT_PRIMARY_ACTION,
          )
            ? cn.columnItemShow
            : ''
        }`}
        to={generatePath(ROUTES.PRIMARY_ACCOUNT_EDIT, {
          categoryId: categoryId as string,
          groupId: groupId as string,
          primaryAccountId: item.id,
        })}
      >
        <span className={cn.columnItemNumber}>{item?.number}</span>
        {item.description}
      </NavLink>
    ));
  }
  return (
    <div className={`${cn.column} ${cn.primaryAccountsColumn}`}>
      <ColumnHead
        title="Primary account"
        path={path}
        linkIsVisible={activePermissions?.includes(
          PermissionEnum.ACCOUNTS_CHART_ADD_PRIMARY_ACTION,
        )}
      />
      {content}
    </div>
  );
};

export default ColumnPrimaryAccounts;
